import { numFormat, valToString } from '@utils/tool';
import { Tooltip } from 'antd';
const maxLength = 200; // input框最大长度
import AiIconImg from '@assets/image/IconAI.svg';
import {
  DataFlagEnum,
  StatusAiEnum,
  StatusAiTextEnum
} from '@views/pages/AnnouncementList/announcement';

const use_ALL_SubMatter_COLUMNS = (detailData: any) => {
  return [
    {
      title: '产品分类',
      dataIndex: 'productLineName',
      key: 'productLineName'
    },
    {
      title: '标的物',
      dataIndex: 'subjectMatterName',
      key: 'subjectMatterName'
    },
    {
      title: 'AI预识别产品线',
      dataIndex: 'productLineAi',
      key: 'productLineAi',
      width: 130,
      render: (val: string, record: any) => {
        // 直销直接显示-- 经销按下列逻辑显示
        if (detailData.dataFlag === DataFlagEnum.directSelling) {
          return '--';
        }
        const valueRender = (value: string) => {
          return (
            <div className="class-ai-wrapper">
              <span>{value || ''}</span>
            </div>
          );
        };
        return valueRender(val);
      }
    },
    {
      title: 'AI预识别',
      dataIndex: 'classTypeValueAi',
      key: 'classTypeValueAi',
      width: 110,
      render: (val: string, record: any) => {
        // 直销直接显示-- 经销按下列逻辑显示
        if (detailData.dataFlag === DataFlagEnum.directSelling) {
          return '--';
        }
        const aiFlag = record.aiFlag;
        const valueRender = (value: string) => {
          return (
            <div className="class-ai-wrapper">
              <span>{value}</span>
              <Tooltip
                rootClassName="class-ai-tooltip"
                placement="bottom"
                title={record.reasoningAi}
                color="#fff"
              >
                <img className="ai-icon" src={AiIconImg} alt="ai" />
              </Tooltip>
            </div>
          );
        };
        const manualRender = () => (
          <div className="class-ai-wrapper no-class-ai">
            <span>{StatusAiTextEnum.manual}</span>
          </div>
        );
        if (aiFlag) {
          if (
            record.statusAi === StatusAiEnum.FAILED ||
            record.statusAi === StatusAiEnum.RUNNING
          ) {
            return valueRender(record.statusValueAi);
          }
          if (val) {
            return valueRender(val);
          } else {
            return manualRender();
          }
        }
        return manualRender();
      }
    },
    {
      title: '标的物品牌',
      width: 150,
      dataIndex: 'subjectMatterBrand',
      key: 'subjectMatterBrand'
    },
    {
      title: '标的物型号',
      width: 150,
      dataIndex: 'subjectMatterModel',
      key: 'subjectMatterModel'
    },
    {
      title: '项目是否要求国产',
      width: 150,
      dataIndex: 'importType',
      key: 'importType',
      render: (text: number) => {
        return text !== undefined && text !== null
          ? text == 1
            ? '是'
            : '否'
          : '';
      }
    },
    {
      title: '标的物中标单价(万元)',
      dataIndex: 'subjectMatterPrice',
      key: 'subjectMatterPrice',
      render: (val: any, record: any) => {
        const text = numFormat(val);
        return (
          !text || text + ' ' + valToString(record.subjectMatterCurrencyValue)
        );
      }
    },
    {
      title: '数量',
      key: 'subjectMatterNumber',
      dataIndex: 'subjectMatterNumber'
    },
    {
      title: '标的物中标总价(万元)',
      key: 'totalAmount',
      dataIndex: 'totalAmount',
      render: (val: any, record: any) => {
        const text = numFormat(val);
        return (
          !text || text + ' ' + valToString(record.totalAmountCurrencyValue)
        );
      }
    },
    // {
    //   title: '预计采购时间',
    //   key: 'estimatedPurchaseTime',
    //   dataIndex: 'estimatedPurchaseTime',
    //   render: (val: any, record: any) => {
    //     return <div>{val ? dayjs(val).format(DEFAULT_DATE_FORMAT) : ''}</div>;
    //   }
    // },
    {
      title: '中标商',
      key: 'successfulCompany',
      dataIndex: 'successfulCompany'
    }
    // {
    //   title: '中标金额',
    //   width: 150,
    //   key: 'successfulPrice',
    //   dataIndex: 'successfulPrice',
    //   render: (record: number, data: any) => {
    //     return record
    //       ? `${record} (${data.successfulPriceCurrencyValue || '空'})`
    //       : '';
    //   }
    // },
    // {
    //   title: '中标金额备注',
    //   width: 150,
    //   key: 'successfulPriceRemark',
    //   dataIndex: 'successfulPriceRemark'
    // },
    // {
    //   title: '主要配置',
    //   width: 150,
    //   key: 'majorDispositions',
    //   dataIndex: 'majorDispositions'
    // }
  ];
};
const ADDSUBJECTMATTER_DETAIL = [
  {
    label: '产品分类',
    required: true,
    type: 'select',
    name: 'productLineKey',
    optionsListKey: 'productLine'
  },
  {
    label: '标的物',
    required: true,
    type: 'input',
    name: 'subjectMatterName'
  },
  // {
  //   label: '制造商',
  //   required: false,
  //   type: 'input',
  //   name: 'subjectMatterBrand'
  // },
  {
    label: '标的物品牌',
    required: false,
    type: 'select',
    name: 'subjectMatterBrandKey',
    optionsListKey: 'subjectMatterBrand'
  },
  {
    label: ' ',
    required: false,
    type: 'input',
    name: 'subjectMatterBrand',
    placeholder: '填写制造商',
    maxLength
  },
  {
    label: '标的物型号',
    required: false,
    type: 'input',
    name: 'subjectMatterModel'
  },
  {
    label: '项目是否要求国产',
    required: false,
    type: 'checkbox',
    name: 'importType',
    optionsListKey: 'importType',
    className: 'client_import_type'
  },
  {
    label: '标的物中标单价(万元)',
    required: false,
    type: 'amount',
    disabled: true,
    name: 'subjectMatterPrice'
  },
  {
    label: '数量',
    required: false,
    type: 'step',
    name: 'subjectMatterNumber',
    max: 1000,
    min: 1
  },
  {
    label: '标的物中标总价(万元)',
    required: false,
    type: 'amount',
    name: 'totalAmount'
  },
  // {
  //   label: '预计采购时间',
  //   required: false,
  //   type: 'time',
  //   name: 'estimatedPurchaseTime'
  // },
  {
    label: '中标商',
    required: false,
    type: 'input',
    name: 'successfulCompany'
  }
  // {
  //   label: '中标金额(如未填写，请备注说明)',
  //   required: false,
  //   type: 'amount',
  //   name: 'successfulPrice',
  //   placeholder: '中标金额'
  // },
  // {
  //   label: '中标金额备注',
  //   required: false,
  //   type: 'input',
  //   name: 'successfulPriceRemark'
  // },
  // {
  //   label: '主要配置',
  //   required: false,
  //   type: 'input',
  //   name: 'majorDispositions'
  // }
  // {
  //   label: '公告链接',
  //   required: true,
  //   type: 'input',
  //   name: 'majorDispositions'
  // }
];

export enum SubjectMatterStatus {
  '未创建项目',
  '已创建项目',
  '标记不相关',
  '已关联项目'
}

export { ADDSUBJECTMATTER_DETAIL, use_ALL_SubMatter_COLUMNS };
